export default "__VITE_ASSET__DaKVuHex__"